import { render, staticRenderFns } from "./ProCredentials.vue?vue&type=template&id=23a6347e&scoped=true"
import script from "./ProCredentials.vue?vue&type=script&lang=js"
export * from "./ProCredentials.vue?vue&type=script&lang=js"
import style0 from "./ProCredentials.vue?vue&type=style&index=0&id=23a6347e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a6347e",
  null
  
)

export default component.exports